import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const DataInputCard = ({ 
  title, 
  icon: Icon, 
  iconColor, 
  description, 
  children, 
  className = "" 
}) => {
  return (
    <Card className={`shadow-lg ${className}`}>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Icon className={`w-6 h-6 text-${iconColor}-600`} />
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {description && (
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
            {description}
          </p>
        )}
        {children}
      </CardContent>
    </Card>
  );
};

export default DataInputCard;
